export class Personal {
  id: number;
  Component: string;
  Jan: number;
  Feb: number;
  Mar: number;
  Apr: number;
  May: number;
  Jun: number;
  Jul: number;
  Aug: number;
  Sep: number;
  Oct: number;
  Nov: number;
  Dec: number;
  YTD: number;
}

export class Process {
  id: number;
  Component: string;
  Jan: number;
  Feb: number;
  Mar: number;
  Apr: number;
  May: number;
  Jun: number;
  Jul: number;
  Aug: number;
  Sep: number;
  Oct: number;
  Nov: number;
  Dec: number;
  YTD: number;
}

export class PersonalProcess {
  personalData: Personal[];
  processData: Process[];
}

export class kpiData{
  Id: number;
  ComponentName: string= "";
  ToolTip: string= "";
  WeightingFactor: string = "";
  BelowTarget: string= "";
  AboveTarget: string= "";
  PreviousTarget: string= "";
  CurrentTarget: string= "";
  CurrentResult: string= "";
  CurrentWFTraficLight: string= "";
  Jan: string;
  Feb: string;
  Mar: string;
  Apr: string;
  May: string;
  Jun: string;
  Jul: string;
  Aug: string;
  Sep: string;
  Oct: string;
  Nov: string;
  Dec: string;
}

export class ActionData{
  Id: number;
  Unit: string;
  Open: number;
  Done: number;
  Accepted: number;
  Closed: number;
  PassedDueDate: number;
  UnitId:number;
}

export class ContractorData {
  id: number;
  Unit: string;
  Department: string;
  Jan: string;
  Feb: string;
  Mar: string;
  Apr: string;
  May: string;
  Jun: string;
  Jul: string;
  Aug: string;
  Sep: string;
  Oct: string;
  Nov: string;
  Dec: string;
  Total: string;
  Target: string;
}

export class CompanyData {
  id: number;
  Unit: string;
  Department: string;
  Jan: string;
  Feb: string;
  Mar: string;
  Apr: string;
  May: string;
  Jun: string;
  Jul: string;
  Aug: string;
  Sep: string;
  Oct: string;
  Nov: string;
  Dec: string;
  Total: string;
  Target: string;
}

export class ContractorCompanyData{
  contractorData: ContractorData[];
  companyData: CompanyData[];
}

export class SafetyCompany {
  id: number;
  Title: string;
  Jan: string;
  Feb: string;
  Mar: string;
  Apr: string;
  May: string;
  Jun: string;
  Jul: string;
  Aug: string;
  Sep: string;
  Oct: string;
  Nov: string;
  Dec: string;
  Total: string;
  Target: string;
  UnitId:number
}

export class Waste{
  Id: number;
  category: string;
  HazardousWasteOily: number;
  HazardousWasteChemical: number;
  HazardousWasteDrilling: number;
  HazardousWasteOther: number;
  NonHazardScrap: number;
  NonHazardWood: number;
  NonHazardPlastic: number;
  NonHazardDomestic: number;
  NonHazardKitchen: number;
  SewageWater: number;
  OBMDisp: number;
  NumOfConsignmentNote: number;
}

export class Energy{
  Id: number;
  category: string;
  NaturalGasProd: number;
  FuelGasGen: number;
  FuelGasTreater: number;
  AllGasFlared: number;
  TotalProducedWater: number;
  PWReInjected: number;
  PWEvaporated: number;
  WaterAbstracted: number;
  EPFDGS: number;
  CampDGS: number;
  ContractorDGS: number;
  Vehicle: number;
  Other: number;
  WellsDGS: number;
  WaterConsumption: number;
}

export class ObservationData {
  Id: number;
  Unit: string;
  Jan: number;
  Feb: number;
  Mar: number;
  Apr: number;
  May: number;
  Jun: number;
  Jul: number;
  Aug: number;
  Sep: number;
  Oct: number;
  Nov: number;
  Dec: number;
  Total: number;
}

export class PDPermission {
  public PD_Add: boolean = false;
  public PD_Add_Unit: boolean = false;
  public PD_Admin_Unit: boolean = false;
  public PD_Admin: boolean = false;
  public PD_ContractHolder_Approve: boolean =false;
}

export class ObsTypeData{
  Id: number;
  UnitId: number;
  UnitName: string;
  Conversation: number;
  Safe: number;
  Act: number;
  Observation: number;
  Unsafe: number;
  Condition: number;
}

export class ActionPriority{
  id: number;
  category: string;
  Low: number;
  Medium: number;
  High: number;
  UnitId:number;
}

export class IncidentHighPotential{
  Id: number;
  category: string;
  Yes: number;
  No: number;
  UnitId:number;
}

export class ObservationByObserver{
  Id: number;
  BaseUnit: string;
  FullName: string;
  Jan: number;
  Feb: number;
  Mar: number;
  Apr: number;
  May: number;
  Jun: number;
  Jul: number;
  Aug: number;
  Sep: number;
  Oct: number;
  Nov: number;
  Dec: number;
  Total: number;
  UnitId:number;
  User:number;
}

export class ObservationAction{
  Id: number;
  Unit: string;
  WithAction: number;
  WithoutAction: number;
  UnitId:number
}

export class ManHourCalculation{
  Id: number;
  Unit: string;
  StaffHours: number;
  ContractorHours: number;
  UnitId:number;
}

export class HeadCount{
  Id: number;
  Unit: string;
  StaffCount: number;
  ContractorCount: number;
  UnitId:number;
}

export class KPIDetails {
  Id: number;
  Name: string;
  ToolTip: string;
}

export class KPITargets {
  Id: number;
  Year: number;
  KPIId: number;
  KPIName:string = "";
  WeightingFactor: string = "";
  BelowTarget: string= "";
  AboveTarget: string= "";
  PreviousTarget: string= "";
  CurrentTarget: string= "";
  IsActive: boolean = true;
  IsDelete?:boolean = false;
}

